import request from '../utils/request'

export function getDubCate () {
  return request({
    url: '/dubbing_examples/list_category',
    method: 'post'
  })
}

export function getDubTpl (data) {
  return request({
    url: '/dubbing_examples/list_examples/v2',
    method: 'post',
    data
  })
}
